import {APP_SETTINGS_PREFIX} from "./preferences_slice.js";
import {setPreference} from "./set_preference.js";

export const setAppSetting = (k, v) => setPreference(`${APP_SETTINGS_PREFIX}.${k}`, v);
